"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMat4 = createMat4;
exports.transformVector = transformVector;
exports.mod = mod;
exports.lerp = lerp;

var _scale = _interopRequireDefault(require("gl-vec4/scale"));

var _transformMat = _interopRequireDefault(require("gl-vec4/transformMat4"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Helper, avoids low-precision 32 bit matrices from gl-matrix mat4.create()
function createMat4() {
  return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
} // Transforms a vec4 with a projection matrix


function transformVector(matrix, vector) {
  var result = (0, _transformMat.default)([], vector, matrix);
  (0, _scale.default)(result, result, 1 / result[3]);
  return result;
}

function mod(value, divisor) {
  var modulus = value % divisor;
  return modulus < 0 ? divisor + modulus : modulus;
}

function lerp(start, end, step) {
  return step * end + (1 - step) * start;
}
//# sourceMappingURL=math-utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/viewport-mercator-project/dist/es5/math-utils.js
// module id = 89
// module chunks = 35783957827783